import { h } from '@stencil/core';
import { pesIconSizes } from '@pes-ui/utils';
export class CommerceConnectorItems {
  constructor() {
    this.favoriteRetailerIconClick = (e, distributor) => {
      e.preventDefault();
      this.favoriteRetailIconClick.emit(distributor);
    };
    this.renderItem = (distributor) => {
      const { isAvailable, priceFormatted, price } = distributor;
      return (h("a", { class: {
          'cc-item': true,
          'cc-item--disable': !isAvailable,
          'cc-item--favorite': this.isFavoriteBlock,
        }, href: distributor.buyUrl, target: "_blank" }, h("div", { class: "cc-item__icon cc-item__icon--new-window" }, h("pes-icon", { size: pesIconSizes.MICRO }, "action_new_window")), h("div", { class: "cc-item__logo" }, h("img", { src: distributor.logoUrl, alt: distributor.name, title: distributor.name })), h("div", { class: "cc-item__info" }, h("div", { class: {
          'cc-item__stock': true,
          'cc-item__stock--in': isAvailable,
        } }, distributor.stockLabel), distributor.showPrice && (h("div", { class: "cc-item__price" }, price ? priceFormatted : this.priceUnavailableLabel))), h("button", { type: "button", class: "cc-item__icon cc-item__icon--favorite", onClick: (e) => {
          this.favoriteRetailerIconClick(e, distributor);
        } }, h("pes-icon", { size: pesIconSizes.MICRO, class: "favorite-icon" }, distributor.isFavorite ? 'star_plain' : 'star_stroke'))));
    };
    this.distributors = undefined;
    this.priceUnavailableLabel = undefined;
    this.isFavoriteBlock = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: { 'cc-items-wrapper': true, 'cc-items-wrapper--favorite': this.isFavoriteBlock } }, this.distributors.map(this.renderItem)));
  }
  static get is() { return "pes-cc-items"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["items.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["items.css"]
    };
  }
  static get properties() {
    return {
      "distributors": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Distributor[]",
          "resolved": "Distributor[]",
          "references": {
            "Distributor": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "priceUnavailableLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "price-unavailable-label",
        "reflect": false
      },
      "isFavoriteBlock": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-favorite-block",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get events() {
    return [{
        "method": "favoriteRetailIconClick",
        "name": "favoriteRetailIconClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "Distributor",
          "resolved": "{ id: string; name: string; logoUrl: string; isAvailable: boolean; buyUrl: string; stockLabel: string; showPrice?: boolean; price?: number; priceFormatted?: string; currency?: string; isFavorite: boolean; retailerSite: string; }",
          "references": {
            "Distributor": {
              "location": "import",
              "path": "../types"
            }
          }
        }
      }];
  }
  static get elementRef() { return "el"; }
}
